import { FC, RefObject, useRef } from "react";
import ComponentClassnames from "../../../../types/component-classnames";
import classNames from "classnames";

type Props = {
  classNames?: ComponentClassnames & {
    input?: string;
  };
  value: string | undefined;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  hasError?: boolean;
  idForTesting?: string;
};

const TextareaInputComponent: FC<Props> = (props) => {
  const inputWrapperClassnames = classNames(
    "form_textarea",
    props.classNames?.root,
    props.hasError && "error",
    props.isDisabled && "disabled",
  );
  const inputClassnames = classNames(
    "form_textarea__input",
    props.classNames?.input,
  );

  const inputWrapperRef: RefObject<HTMLLabelElement | null> = useRef(null);

  const onInputFocus = () => {
    inputWrapperRef?.current?.classList.add("active");
    if (props.onFocus) {
      props.onFocus();
    }
  };

  const onInputBlur = () => {
    inputWrapperRef?.current?.classList.remove("active");

    if (props.onBlur) props.onBlur();
  };

  const onChange = (value: string) => {
    if (props.onChange) props.onChange(value);
  };
  return (
    <label ref={inputWrapperRef} className={inputWrapperClassnames}>
      <textarea
        value={props.value ?? ""}
        placeholder={props.placeholder}
        className={inputClassnames}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
        autoCorrect="false"
        spellCheck="false"
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        readOnly={props.isReadOnly || props.isDisabled}
        disabled={props.isDisabled}
        data-test-id={props.idForTesting}
      />
    </label>
  );
};

export default TextareaInputComponent;
